import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";

const initialState = {
  univCategories: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
  noResults: false,
};

export const univCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_UNIV_CATEGORIES: {
      const { univCategories, status, err } = action.payload;
      return {
        ...state,
        univCategories,
        status,
        err,
        noResults: !univCategories.length,
      };
    }
    case types.SET_UNIV_CATEGORIES_REQUEST_STATUS:
      return { ...state, ...action.payload };
    case types.RESET_UNIV_CATEGORIES:
      return { ...initialState };
    default:
      return state;
  }
};
